export default __webpack_public_path__ + "static/media/gateway.123b0e5a.png";